import { useFieldArray, useWatch } from 'react-hook-form';
import Button from 'style-guide/Button';
import DropdownV2 from 'style-guide/DropdownV2';
import { Down, Plus, Trash } from 'style-guide/Icons';
import { Input } from 'style-guide/Input';

const defaultOptions = [
  { name: '0', value: '0' },
  { name: '1', value: '1' },
  { name: '1.5', value: '1.5' },
  { name: '2', value: '2' },
  { name: '2.5', value: '2.5' },
  { name: '3', value: '3' },
  { name: '3.5', value: '3.5' },
  { name: '4', value: '4' },
  { name: '5', value: '5' },
  { name: '6', value: '6' },
  { name: '7', value: '7' },
];
const rangeLengths = {
  min: 3,
  max: 7,
};
const Range = ({ control, register, index, question, errors, trigger }) => {
  const { fields, append, remove, update } = useFieldArray({
    control,
    name: `${question}.${index}.questionAnswers`,
  });
  const value = useWatch({
    name: `${question}.${index}.questionAnswers`,
    control,
  });
  return (
    <>
      {fields.map((rangeField, rangeIndex) => (
        <div key={rangeField.id} className='d-flex align-items-end'>
          <div className='mr--16'>
            <DropdownV2
              options={defaultOptions}
              className='range-from'
              placement='bottom'
              onClickItem={(item) =>
                update(rangeIndex, { ...rangeField, rangeFrom: item, answer: value[rangeIndex]?.answer || '' })
              }
            >
              <Input
                label='Range From'
                Suffix={Down}
                readOnly
                value={value[rangeIndex]?.rangeFrom}
                placeholder='1'
                className='range'
                required
                {...register(`${question}.${index}.questionAnswers.${rangeIndex}.rangeFrom`)}
                error={errors?.questions?.[index]?.questionAnswers?.[rangeIndex]?.rangeFrom}
              />
            </DropdownV2>
          </div>
          <div className='mr--16'>
            <DropdownV2
              options={defaultOptions}
              className='range-to'
              placement='bottom'
              onClickItem={(item) => {
                update(rangeIndex, { ...rangeField, rangeTo: item, answer: value[rangeIndex]?.answer || '' });
                trigger(`${question}.${index}.questionAnswers.${rangeIndex}.rangeTo`);
              }}
            >
              <Input
                label='Range To'
                Suffix={Down}
                readOnly
                value={value[rangeIndex]?.rangeTo}
                placeholder='1'
                className='range mb--24'
                required
                {...register(`${question}.${index}.questionAnswers.${rangeIndex}.rangeTo`)}
                error={errors?.questions?.[index]?.questionAnswers?.[rangeIndex]?.rangeTo}
              />
            </DropdownV2>
          </div>
          <Input
            className='answer-input'
            placeholder='Write Answer'
            {...register(`${question}.${index}.questionAnswers.${rangeIndex}.answer`)}
            required
            error={errors?.questions?.[index]?.questionAnswers?.[rangeIndex]?.answer}
          />
          {fields.length > 2 && (
            <Button
              variant='text'
              $danger
              onClick={() => {
                remove(rangeIndex);
              }}
              className='mb--24 ml--8'
            >
              <Trash />
            </Button>
          )}
        </div>
      ))}
      <div className='d-flex align-items-end'>
        <Button
          variant='link'
          prefix={<Plus />}
          className='mb--8'
          size='small'
          onClick={() => {
            append({ rangeFrom: '', rangeTo: '', answer: '' });
          }}
          disabled={value.length >= rangeLengths.max}
        >
          Add Range
        </Button>
      </div>
    </>
  );
};
export default Range;
